"use client";

import { useParams, useRouter } from "next/navigation";
import ProfileHeader from "@/components/about/leaders/leader-profile/Header";
import ProfileInfo from "@/components/about/leaders/leader-profile/ProfileInfo";
import ProfileQuote from "@/components/about/leaders/leader-profile/Quote";
import { agents } from "@/utils/agentsInfo";
import { navigateWithQueryParams } from "@/utils/navigationUtils";
import Footer from "@/components/Footer";

export default function Content() {
  const router = useRouter();
  const params = useParams();

  const slug = params?.slug as string;
  const agent = agents[slug];

  if (!agent) {
    navigateWithQueryParams(router, "/careers/agents");
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      <main>
        <ProfileHeader
          name={agent.name}
          title={agent.title}
          license={agent.license}
          location={agent.location}
        />
        <ProfileInfo
          leader={{
            ...agent,
            quote: agent.quote || "",
            quoteAuthor: agent.quoteAuthor || "",
          }}
        />
        {agent.quote && (
          <ProfileQuote quote={agent.quote} author={agent.quoteAuthor || ""} />
        )}
      </main>
      <Footer />
    </div>
  );
}
